import { createFileRoute } from '@tanstack/react-router'
import { FarmerOnboardingForm } from '@/components/forms/farmer-onboarding-form';

export const Route = createFileRoute('/_offline-forms/farmer-onboarding')({
  component: FarmerOnboardingComponent,
})

function FarmerOnboardingComponent() {

  return (
    <div className="flex items-center justify-center">
      <div className="h-full w-full max-w-xl px-4 flex flex-col gap-4">
        <FarmerOnboardingForm />
      </div>
    </div>
  )
}
